import {
  TableCell,
  TableHeader,
  TableRow,
  Typography,
} from "@codat/orchard-ui";
import React, { useState } from "react";

import { ApiKeyData } from "../apiKeyData";
import { HelpTooltip } from "../HelpTooltip";
import { ApiKeysActionCell, ApiKeysDataCell } from "./ApiKeysCells";
import styles from "./ApiKeysTableStyles.module.scss";

export interface ApiKeysTableProps {
  keys: ApiKeyData[];
  onKeyDelete: (keyId: string) => void;
}

export const ApiKeysTable: React.FC<ApiKeysTableProps> = (props) => {
  const { keys, onKeyDelete } = props;

  const [unmaskedKeyIds, setMaskedKeys] = useState<string[]>([]);

  const onMaskToggle = (id: string) => {
    if (unmaskedKeyIds.includes(id)) {
      setMaskedKeys(unmaskedKeyIds.filter((key) => key !== id));
    } else {
      setMaskedKeys([...unmaskedKeyIds, id]);
    }
  };

  const keysWithMasked = keys.map((k) => ({
    ...k,
    isMasked: !unmaskedKeyIds.includes(k.id),
  }));

  return (
    <table
      className={styles.apiKeyTable}
      data-testid="api-keys-table"
      aria-busy="false"
    >
      <thead>
        <TableRow>
          <TableHeader
            label={
              <Typography as="p" variant="body_sm">
                Name
              </Typography>
            }
          />
          <TableHeader
            className={styles.authorizationHeaderCell}
            label={
              <div className={styles.headerCell}>
                <Typography as="p" variant="body_sm">
                  Authorization header
                </Typography>
                <HelpTooltip />
              </div>
            }
          />
          <TableHeader
            className={styles.apiKeyHeaderCell}
            label={
              <Typography as="p" variant="body_sm">
                API key
              </Typography>
            }
          />
          <TableHeader
            className={styles.createdHeaderCell}
            label={
              <Typography as="p" variant="body_sm">
                Created
              </Typography>
            }
          />
          <TableHeader className={styles.actionsHeaderCell} label="" />
        </TableRow>
      </thead>

      <tbody>
        {keysWithMasked.map((k, i) => (
          <TableRow key={k.id}>
            <TableCell className={styles.nameCell}>
              {k.name ?? "API key"}
            </TableCell>
            <TableCell>
              <ApiKeysDataCell
                kind="auth-header"
                apiKey={k.apiKey}
                isMasked={k.isMasked}
              />
            </TableCell>
            <TableCell>
              <ApiKeysDataCell
                kind="api-key"
                apiKey={k.apiKey}
                isMasked={k.isMasked}
              />
            </TableCell>
            <TableCell>
              {k.createdDate
                ? new Date(k.createdDate).toLocaleDateString("en-us", {
                    dateStyle: "medium",
                  })
                : "-"}
            </TableCell>
            <TableCell>
              <ApiKeysActionCell
                isMasked={k.isMasked}
                isOnlyKey={keysWithMasked.length === 1}
                index={i}
                onMaskToggle={() => onMaskToggle(k.id)}
                onDeleteClick={() => onKeyDelete(k.id)}
              />
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </table>
  );
};
